'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _WarningFilled = _interopRequireDefault(require('./lib/icons/WarningFilled'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _WarningFilled;
exports.default = _default;
module.exports = _default;